// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"_1Ug3DFi2Yeg8ijuitf4G4F","mainImg":"_37DISB_02V4CtzsqbYK740","subtitle":"_2UPOf_UfJA2oL3vtVqOzZH","text":"_3zjsIQC-mdM_pksv1e10tP","spacer":"_1oocVzTgpd06VHOPcH-Hmr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CienieKsiazka/CienieKsiazka.css
// module id = 57
// module chunks = 0